import { ProductRecord } from './product.model';
import { OneOfListElements } from './project.model';
import { ResultsRecord } from './unit.model';

export const sortByAlternatives = {
  name: 'Name',
  co2: 'kgCO2e',
  cost: 'Expenses',
  position: 'Position',
};

export type SortByAlternative = keyof typeof sortByAlternatives;

export type SortByNameOptions = {
  sortBy: 'name';
  productLookup: ProductRecord;
  resultsRecord?: ResultsRecord;
};
export type SortByConversionFactorsOptions = {
  sortBy: 'co2' | 'cost';
  productLookup?: ProductRecord;
  /** Results by element id (from proposal.resultsRecord). Required for co2/cost sort. */
  resultsRecord?: ResultsRecord;
};
export type SortByPositionOptions = {
  sortBy: 'position';
  productLookup?: ProductRecord;
  resultsRecord?: ResultsRecord;
};
export type SortOptions =
  SortByNameOptions | SortByConversionFactorsOptions | SortByPositionOptions;

export type ElementSortFn<T extends OneOfListElements> = (a: T, b: T) => number;

export type IInsertSortPlacement = 'before' | 'after' | 'last' | 'first';
